import { SettingsPlaceholder } from "@/pages/settings/settings-placeholder";

export function FieldsSettingsPage() {
  return (
    <SettingsPlaceholder
      title="Fields"
      description="Custom metadata fields on assets. Deferred to Phase 2."
    />
  );
}
